export default {
  authAccessToken: "",
  authRefreshToken: "",
  role: 1, // 1 -> user, 2 -> admin
  loader: false,
  alertMessage: [],
  showMessage: false,
  initURL: "",
  userInfo: {},
  expiresIn: ""
};
